import PropTypes from 'prop-types';

const EditPicturePropType = {
  updatePicture: PropTypes.func,
  selectedMember: PropTypes.instanceOf(Object),
  selectedGroup: PropTypes.instanceOf(Object),
};

export default EditPicturePropType;
